import React, { FC, PropsWithChildren, useEffect } from 'react';
import {
  createInstance,
  FeatureFlagProvider as DVFeatureFlagProvider
} from '@walmart-dataventures/feature-flag-sdk-react';

import config from '../config/config';
import useLocalStorage from '../hooks/useLocalStorage.ts';

const FeatureFlagProvider: FC<PropsWithChildren> = ({ children }) => {
  const panelistId = useLocalStorage('panelistId');

  const client = createInstance('customer-spark-ui', {
    initOption: 'sdkKey',
    sdkKey: config.featureFlagSdkKey,
    autoUpdateConfigChanges: true,
    autoUpdateInterval: 5 * 60 * 1000 // 5 minutes
  });

  useEffect(() => {
    /**
     * There is a bug in the DV SDK where if the
     * user changes (logout and login in our case), the client doesn't
     * update the user automatically. So we need to set the user when that happens.
     *
     * If the panelistId is an empty string, we set it to null.
     * Optimizely will automatically generate a random user ID in these cases.
     * */
    client.setUser({
      id: panelistId || null,
      attributes: {
        env: config.env
      }
    });
  }, [panelistId, client]);

  return (
    <DVFeatureFlagProvider
      featureFlagClient={client}
      user={{
        id: panelistId,
        attributes: {
          env: config.env
        }
      }}
      timeout={10000}
    >
      {children}
    </DVFeatureFlagProvider>
  );
};

export default FeatureFlagProvider;
